// extracted by mini-css-extract-plugin
export default {"userOptionContainer":"UserOption_userOptionContainer__lwcUX"};